import { useState } from 'react';

import { useLanguage } from '../contexts/LanguageContext';

// T040 [US2]: Add language switching to LanguageSelector with visual feedback and transition animations (FR-009, FR-029)
export function LanguageSelector() {
  const { currentLang, setLanguage } = useLanguage();
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleLanguageChange = async (lang: string) => {
    // Don't do anything if clicking the already-selected language
    if (lang === currentLang || isTransitioning) {
      return;
    }

    // Set transitioning state for visual feedback
    setIsTransitioning(true);

    try {
      await setLanguage(lang);
    } finally {
      // Remove transitioning state after a short delay for smooth transition
      setTimeout(() => {
        setIsTransitioning(false);
      }, 300);
    }
  };

  const toggleLanguage = () => {
    handleLanguageChange(currentLang === 'en' ? 'th' : 'en');
  };

  return (
    <div className="flex items-center" role="group" aria-label="Language selector">
      <button
        onClick={toggleLanguage}
        aria-label={`Switch to ${currentLang === 'en' ? 'Thai' : 'English'}`}
        disabled={isTransitioning}
        className="flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium bg-dark-100/50 border border-white/10 text-text-secondary hover:text-neon-cyan hover:bg-white/5 hover:border-neon-cyan/30 transition-all duration-300 focus-ring"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="opacity-70"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          <path d="M2 12h20" />
        </svg>
        <span>{currentLang === 'en' ? 'ไทย' : 'EN'}</span>
      </button>
    </div>
  );
}
